import { memo, useEffect, useState } from "react";
import { Button, Checkbox, Input, MenuProps, Skeleton, Table, TableProps } from "antd";
import { useTranslation } from "react-i18next";
import { mdlFactSheetInfo } from "../../models/domain/FactSheetInfo";
import { mdlLanguage } from "../../models/ui-models/Language";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel, faFilePdf, faGlobe, faTimes } from "@fortawesome/free-solid-svg-icons";
import { InputHelper } from "../../utils/InputHelper";
import { mdlFactSheetInfoGroup } from "../../models/domain/FactSheetRoomInfoGroup";
import { enmFactSheetDataType } from "../../models/enums/FactSheetRoomInfoGroupType copy";
import _ from "lodash";
import { mdlBasicFactSheetItemCategory } from "../../models/service-models/fact-sheet/BasicFactSheetItemCategory";
import { useMutation } from "react-query";
import { FactSheetService } from "../../services/FactSheetService";
import { mdlFactSheetItemsRequest } from "../../models/service-models/fact-sheet/FactSheetItemsRequest";
import { mdlFactSheetItemUpdateInsertRequest } from "../../models/service-models/fact-sheet/FactSheetItemUpdateInsertRequest";
import { toast } from "react-toastify";
import { mdlFactSheetCategory } from "../../models/ui-models/FactSheetCategory";
import { mdlFactSheetItem } from "../../models/ui-models/FactSheetItem";

export type FactSheetInfosProps = {
    selectedLanguage?: mdlLanguage;
    activeCell?: string;
    selectedHotel?: string;
    fnActiveCellChange?: Function;
    selectedCateogry?: mdlBasicFactSheetItemCategory;
    updateTemplateData?: Function;
}

export const FactSheetInfos = memo(function FactSheetInfos(props: FactSheetInfosProps) {
    const { t } = useTranslation();
    const [cellText, setCellText] = useState<string>();
    const [activeCell, setActiveCell] = useState<string>();
    const [selectedCateogryItems, setSelectedCategoryItems] = useState<mdlFactSheetInfoGroup[]>();

    const selector = `table-input`;
    useEffect(() => {
        if ( props.selectedCateogry && props.selectedCateogry.id) {
            let items = [] as mdlFactSheetInfoGroup[];
            setSelectedCategoryItems([])
            setMutateCategoryItems(props.selectedCateogry.id, (data: mdlFactSheetCategory[]) => {
                    items = data.map((category:mdlFactSheetCategory) => {
                        return {
                            key : category.categoryName,
                            haveWithCharge: category.haveWithCharge,
                            data : category.features?.map((item:mdlFactSheetItem) => {
                                return {
                                    id : item?.factSheetId,
                                    value: item?.value,
                                    basicFactSheetId: "",
                                    giataStatus : item.giataStatus ,
                                    dataType : item.dataType ,
                                    isRequired: false,
                                    categoryName: category.categoryName,
                                    questionName: item?.text,
                                    getEnvironmentData: undefined,
                                    sejour: item.sejourStatus,
                                    tourVisio: item.tourvisioStatus,
                                    xml: item?.xmlStatus,
                                    web: item?.webStatus,
                                    pdf: item?.pdfStatus,
                                    isExtra: item?.isExtra ?? false,
                                    haveWithCharge: item?.isExtra ?? false
                                } as mdlFactSheetInfo
                            })
                        } as mdlFactSheetInfoGroup
                        
                        
                    });
                    setSelectedCategoryItems(items)
                })
            }
    }, [props]);

    const saveItem = useMutation({
        mutationFn: (data: mdlFactSheetItemUpdateInsertRequest) => {
            return FactSheetService.UpdateInsertItem(data)
        }
    })
    
    const setMutateSaveItem = async (data: mdlFactSheetItemUpdateInsertRequest, fnSuccess: Function) => {
        const result = await saveItem.mutateAsync(data)
        fnSuccess();
        if (result && result.body && result.body.result) {
            fnSuccess(result.body.result);
        }
    }

    const saveItemObject =  (itemInfo:mdlFactSheetInfo) => {
        if(selectedCateogryItems){
            const updatedSelectedCategoryItems = _.cloneDeep(selectedCateogryItems).map( (x) => {
                return {...x,data:x.data?.map( (y) => {
                    if(y.id == itemInfo.id){
                        return {...y,...itemInfo}
                    }
                    return y;
                })}
            }) as mdlFactSheetInfoGroup[];
            
            const activeItem = updatedSelectedCategoryItems
            .find((group) => group.data?.some((item) => item.id === itemInfo.id))
            ?.data?.find((item) => item.id === itemInfo.id) as mdlFactSheetInfo;

            if(activeItem){
                const request = {
                    hotelId: props.selectedHotel,
                    factSheetId: activeItem.id,
                    value: activeItem.value ?? "",
                    xml: activeItem.xml,
                    web: activeItem.web,
                    pdf: activeItem.pdf,
                    isExtra: activeItem.isExtra,
                }
                setMutateSaveItem(request as mdlFactSheetItemUpdateInsertRequest, (result: boolean) => {
                        props.fnActiveCellChange && props.fnActiveCellChange("")
                        setActiveCell("");
                        toast.success(t("common.success"));
                        setSelectedCategoryItems(updatedSelectedCategoryItems);
                        props.updateTemplateData && props.updateTemplateData(updatedSelectedCategoryItems);
                });
            }
        }
    }

    const getCategoryWithItems = useMutation({
        mutationFn: (categoryId: string) => {
            return FactSheetService.GetItemsByCategoryId({ hotelId:props.selectedHotel,categoryId:categoryId, currentLanguage: props.selectedLanguage?.value } as mdlFactSheetItemsRequest)
        }
    })

    const setMutateCategoryItems = async (categoryId: string, fnSuccess: Function) => {
        const data = await getCategoryWithItems.mutateAsync(categoryId)
        if (data && data.body && data.body.data) {
            fnSuccess(data.body.data);
        }
    }
    function updateObject(keyName:string, newVal:string, object:any) {
        const results:any = {};
        for (var key in object) {
          if (key === keyName) {
            results[key] = newVal;
          } else if (typeof object[key] === "object" && object[key] !== null) {
            results[key] = updateObject(keyName, newVal, object[key]);
          } else {
            results[key] = object[key];
          }
        }
        return results;
      }

    const handleKeyPress = (e: any) => {
        setCellText(e.target.value);
        if (e.key === 'Enter' && selectedCateogryItems) {
            const activeItem = selectedCateogryItems
            .find((group) => group.data?.some((item) => item.id === activeCell))
            ?.data?.find((item) => item.id === activeCell) as mdlFactSheetInfo;
            const name = e.target.getAttribute('name');
            const newItem = updateObject(name,e.target.value,activeItem);
            saveItemObject(newItem) 
        } else if (e.key === 'Escape') {
            props.fnActiveCellChange && props.fnActiveCellChange("")
            setActiveCell("");
            setCellText("");
        }
    }
    const items: MenuProps['items'] = [
        {
            key: 'km',
            label: 'km',
        },
        {
            key: 'm',
            label: 'm',
        },
        {
            key: 'empty',
            label: 'Empty',
        },
    ];

    const handleActiveCell = (id:string, value:string) => {
        setActiveCell(id);
        setCellText(value);
        props.fnActiveCellChange && props.fnActiveCellChange(id)
    }
    const columns: TableProps<mdlFactSheetInfo>['columns'] = [
        {
            title: t("factSheet.hotelInformation.questionName"),
            dataIndex: 'questionName',
            key: 'questionName',
            width:300
        },
        {
            title: t("factSheet.hotelInformation.isExtra"),
            dataIndex: 'value',
            key: 'value',
            render: (_, record) => (
                <>
                    {
                        record.dataType && record.dataType == enmFactSheetDataType.bool as number &&
                        <>
                            <Checkbox onChange={() => { saveItemObject({...record,value:(InputHelper.isNullOrUndefinedOrEmpty(record.value) ? "true" : "")}) } } checked={!InputHelper.isNullOrUndefinedOrEmpty(record.value)}></Checkbox>
                        </>
                    }
                    {
                        record.dataType && record.dataType == enmFactSheetDataType.string &&
                        <>
                            {
                                activeCell && activeCell == record.id ?
                                    <>
                                        <div className="row">
                                            <div className="col">
                                                <Input defaultValue={record.value} onKeyUp={handleKeyPress} autoFocus={true} id="table-input" name="value"></Input>
                                            </div>
                                            <div className="col">
                                                <Button className="btn btn-sm btn-primary d-inline-block ms-2" onClick={() => { saveItemObject({...record,value:cellText}) } } >{t("common.save")}</Button>
                                                <Button className="btn btn-sm btn-danger d-inline-block ms-2" onClick={() => { setActiveCell("");  props.fnActiveCellChange && props.fnActiveCellChange("") }}>{t("common.cancel")}</Button>
                                            </div>
                                        </div>
                                    </>
                                    :
                                    <label onClick={() => { record.id && handleActiveCell(record.id,record.value ?? "") }}>{record.value == undefined || record.value?.trim().length == 0 ?  "..." : record.value}</label>
                            }
                        </>
                    }
                    {
                        record.dataType && record.dataType == enmFactSheetDataType.int &&
                        <>

                            {
                                activeCell && activeCell == record.id ?
                                    <>
                                        <div className="row">
                                            <div className="col">
                                                <Input defaultValue={record.value} onKeyUp={handleKeyPress} autoFocus={true} id="table-input" name="value"></Input>
                                            </div>
                                            <div className="col">
                                                <Button className="btn btn-sm btn-primary d-inline-block ms-2" onClick={() => { saveItemObject({...record,value:cellText}) } } >{t("common.save")}</Button>
                                                <Button className="btn btn-sm btn-danger d-inline-block ms-2" onClick={() => { setActiveCell("");  props.fnActiveCellChange && props.fnActiveCellChange("") }}>{t("common.cancel")}</Button>
                                            </div>
                                        </div>
                                    </>
                                    :
                                    <label onClick={() => { record.id && handleActiveCell(record.id,record.value ?? "") }}>{record.value == undefined || record.value?.trim().length == 0 ?  "..." : record.value}</label>
                            }
                        </>
                    }
                    {
                        record.dataType && record.dataType == enmFactSheetDataType.float &&
                        <>
                            {
                                activeCell && activeCell == record.id ?
                                    <>
                                    <div className="row">
                                        <div className="col">
                                                <Input defaultValue={record.value} onKeyUp={handleKeyPress} autoFocus={true} id="table-input" name="value"></Input>
                                        </div>
                                        <div className="col">
                                            <Button className="btn btn-sm btn-primary d-inline-block ms-2" onClick={() => { saveItemObject({...record,value:cellText}) } } >{t("common.save")}</Button>
                                            <Button className="btn btn-sm btn-danger d-inline-block ms-2" onClick={() => { setActiveCell("");  props.fnActiveCellChange && props.fnActiveCellChange("") }}>{t("common.cancel")}</Button>
                                        </div>
                                    </div>
                                    </>
                                    : 
                                    <label onClick={() => { record.id && handleActiveCell(record.id,record.value ?? "") }}>{record.value == undefined || record.value?.trim().length == 0 ?  "..." : record.value}</label>
                            }
                        </>
                    }
                </>
            ),
        },
        {
            title: t("factSheet.hotelInformation.haveWithCharge"),
            dataIndex: 'haveWithCharge',
            key: 'haveWithCharge',
            hidden:false,
            render: (_, record) => (
                <>
                    {
                        <Checkbox checked={record.haveWithCharge} onChange={() => { saveItemObject({...record,haveWithCharge:!record.haveWithCharge}) } } ></Checkbox>
                    }
                </>
            ),
        },
        {
            title: t("factSheet.hotelInformation.giata"),
            dataIndex: 'giataStatus',
            key: 'giataStatus',
            render: (_, record) => ( ( console.log(record)),
                <>
                    {
                        record.giataStatus &&
                        <>
                            <span className="badge rounded-pill bg-success">{t("common.yes")}</span>
                        </>
                    }
                </>
            ),
        },
        {
            title: t("factSheet.hotelInformation.sejour"),
            dataIndex: 'sejour',
            key: 'sejour',
            render: (_, record) => (
                <>
                    {
                        !InputHelper.isNullOrUndefinedOrEmpty(record.sejour) &&
                        <>
                            <span className="badge rounded-pill bg-success">{t("common.yes")}</span>
                        </>
                    }
                </>
            ),
        },
        {
            title: t("factSheet.hotelInformation.tourVisio"),
            dataIndex: 'tourVisio',
            key: 'tourVisio',
            render: (_, record) => (
                <>
                    {
                        !InputHelper.isNullOrUndefinedOrEmpty(record.tourVisio) &&
                        <>
                            <span className="badge rounded-pill bg-success">{t("common.yes")}</span>
                        </>
                    }
                </>
            ),
        },
        {
            title: t("factSheet.hotelInformation.xml"),
            dataIndex: 'xml',
            key: 'xml',
            render: (_, record) => (
                <>
                    {
                        record.xml &&
                        <>
                            <FontAwesomeIcon icon={faFileExcel} onClick={() => { }}></FontAwesomeIcon>
                        </>
                    }
                </>
            ),
        },
        {
            title: t("factSheet.hotelInformation.web"),
            dataIndex: 'web',
            key: 'web',
            render: (_, record) => (
                <>
                    {
                        record.web &&
                        <>
                            <FontAwesomeIcon icon={faGlobe} onClick={() => { }}></FontAwesomeIcon>
                        </>
                    }
                </>
            ),
        },
        {
            title: t("factSheet.hotelInformation.pdf"),
            dataIndex: 'pdf',
            key: 'pdf',
            render: (_, record) => (
                <>
                    {
                        record.web &&
                        <>
                            <FontAwesomeIcon icon={faFilePdf} onClick={() => { }}></FontAwesomeIcon>
                        </>
                    }
                </>
            ),
        },
    ];
    const colorList = ["primary","secondary","warning","info","success","danger"];
    return (
        <>

            <div className="row">
                {
                    (!selectedCateogryItems || selectedCateogryItems.length == 0) &&
                    <>
                        <Skeleton />
                    </>
                }
                {
                    selectedCateogryItems
                    &&
                    <>
                        {selectedCateogryItems.map((item: mdlFactSheetInfoGroup, index: number) => (
                            <>
                                <div className="col-sm-12">
                                    <h4>
                                        <span className={`badge badge-md badge-dot bg-outline-${colorList[index%colorList.length]}`}>{item.key}</span>
                                    </h4>
                                    <hr />
                                </div>
                                <div className="col-sm-12 mb-4">
                                    <Table<mdlFactSheetInfo>
                                        size="middle"
                                        columns={item.haveWithCharge ? _.cloneDeep(columns) : _.cloneDeep(columns).map((x) => { if(x.key == "haveWithCharge"){x.hidden = true;}return x;})}
                                        pagination={false}
                                        scroll={{ x: 'max-content' }}
                                        dataSource={
                                            item.data?.map((data: mdlFactSheetInfo, index: number)=> ({ ...data, key: index }))
                                        }
                                    />
                                </div>
                            </>
                        ))}
                    </>
                }</div>
        </>
    )
})